import * as firebase from "firebase/app";

import "firebase/firestore";
import {
  Cadastro,
  CadastroSimples,
  repositorio,
  Agenda,
} from "../data/interfaces";

const config = {
  apiKey: "AIzaSyCvV6WVI_ysTT0ecggFcvdCtzEVprDzxAE",
  authDomain: "portalsaude-9c369.firebaseapp.com",
  databaseURL: "https://portalsaude-9c369.firebaseio.com",
  projectId: "portalsaude-9c369",
  storageBucket: "portalsaude-9c369.appspot.com",
  messagingSenderId: "734173809225",
};

firebase.initializeApp(config);
const db = firebase.firestore();

export const doLike = (
  key: string,
  tipo: string,
  qtd: number,
  callback: (rs: boolean) => void
) => {
  firebase
    .firestore()
    .collection(tipo)
    .doc(key)
    .update({ curtida: qtd })
    .then((res) => {
      console.log("Resultado", res);
      return callback(true);
    })
    .catch((error) => {
      console.log(error);
      return callback(false);
    });
};

export const getInformativo = (
  tipo: string,
  callback: (rs: CadastroSimples) => void
) => {
  db.collection(repositorio.CADASTRO_SIMPLES)
    .where("tipo", "==", tipo)
    .get()
    .then((itens) => {
      const key = itens.docs.shift()?.id;
      const dados = { ...itens.docs.shift()?.data() };
      const cadastro: CadastroSimples = { ...dados, key } as CadastroSimples;
      return callback(cadastro);
    })
    .catch((error) => {
      return [];
    });
};

export const getListaPromocao = (
  tipo: string,
  callback: (rs: CadastroSimples[]) => void
) => {
  console.log("Quan e o tipo:", tipo);
  db.collection(repositorio.CADASTRO_SIMPLES)
    .where("tipo", "==", tipo)
    .get()
    .then((itens) => {
      const listTemp: CadastroSimples[] = [];
      itens.docs.forEach((value) => {
        const key = value.id;
        const dados = { ...value.data() };
        const cadastro: CadastroSimples = { ...dados, key } as CadastroSimples;
        listTemp.push(cadastro);
      });
      return callback(listTemp);
    })
    .catch((error) => {
      return [];
    });
};

export const getListaCadastro = (
  tipo: string,
  callback: (rs: Cadastro[]) => void
) => {
  db.collection(repositorio.CADASTRO)
    .where("tipo", "==", tipo)
    .get()
    .then((itens) => {
      const listTemp: Cadastro[] = [];
      itens.docs.forEach((value) => {
        const key = value.id;
        const cadastro = { ...value.data(), key } as Cadastro;
        listTemp.push(cadastro);
      });
      return callback(listTemp);
    })
    .catch((error) => {
      return [];
    });
};

export const getListaBanner = (
  tipo: string,
  callback: (rs: CadastroSimples[]) => void
) => {
  db.collection(repositorio.CADASTRO_SIMPLES)
    .where("tipo", "==", tipo)
    .get()
    .then((itens) => {
      const listTemp: CadastroSimples[] = [];
      itens.docs.forEach((value) => {
        const key = value.id;
        const cadastro = { ...value.data(), key } as CadastroSimples;
        listTemp.push(cadastro);
      });
      return callback(listTemp);
    })
    .catch((error) => {
      return [];
    });
};

export const getAgenda = (callback: (rs: Agenda[]) => void) => {
  db.collection(repositorio.AGENDA)
    .get()
    .then((itens) => {
      const listTemp: Agenda[] = [];
      itens.docs.forEach((value) => {
        const key = value.id;
        const cadastro = { ...value.data(), key } as Agenda;
        listTemp.push(cadastro);
      });
      return callback(listTemp);
    })
    .catch((error) => {
      return [];
    });
};
